/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Achievement_Perfect_WeekInputs */

const en_us2_achievement_perfect_week = /** @type {(inputs: Achievement_Perfect_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfect week`)
};

const pt_br2_achievement_perfect_week = /** @type {(inputs: Achievement_Perfect_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semana perfeita`)
};

const es_419_achievement_perfect_week = /** @type {(inputs: Achievement_Perfect_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semana perfecta`)
};

const pt_pt2_achievement_perfect_week = /** @type {(inputs: Achievement_Perfect_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semana perfeita`)
};

const fr_fr2_achievement_perfect_week = /** @type {(inputs: Achievement_Perfect_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semaine parfaite`)
};

const de_de2_achievement_perfect_week = /** @type {(inputs: Achievement_Perfect_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfekte Woche`)
};

const it_it2_achievement_perfect_week = /** @type {(inputs: Achievement_Perfect_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settimana perfetta`)
};

/**
* | output |
* | --- |
* | "Perfect week" |
*
* @param {Achievement_Perfect_WeekInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const achievement_perfect_week = /** @type {((inputs?: Achievement_Perfect_WeekInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Achievement_Perfect_WeekInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_achievement_perfect_week(inputs)
	if (locale === "es-419") return es_419_achievement_perfect_week(inputs)
	if (locale === "pt-PT") return pt_pt2_achievement_perfect_week(inputs)
	if (locale === "fr-FR") return fr_fr2_achievement_perfect_week(inputs)
	if (locale === "de-DE") return de_de2_achievement_perfect_week(inputs)
	if (locale === "it-IT") return it_it2_achievement_perfect_week(inputs)
	return en_us2_achievement_perfect_week(inputs)
});
export { achievement_perfect_week as "achievement.perfect_week" }